// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3d2Jr","tab":"ProcedureTabs_tab__21Otx"};